import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Card } from "react-bootstrap"
import { Link } from "react-router-dom"
import { FormattedMessage } from "react-intl"
import { showCountryAction } from "../../actions/countriesActions"
import CountryForm from "../../components/forms/CountryForm"
import MaterialIcon from "../../components/elements/MaterialIcon"

class CountryEditPage extends Component {

	state = {
		itemCountriesIndex: -1
	}

	componentDidMount() {

		const { match, history } = this.props

		if (!match.params.id)
			history.push("/countries")

		this.props.showCountryAction(match.params.id, this.handleFinish)
	}

	handleFinish = () => {
		const { countries, match, history } = this.props
		const itemCountriesIndex = countries.data.findIndex(item => (item.id === parseInt(match.params.id, 10)))
		if (itemCountriesIndex === -1)
			history.push("/countries")

		this.setState({ itemCountriesIndex })
	}

	render() {
		const { itemCountriesIndex } = this.state
		const { countries, match } = this.props
		const countryData = itemCountriesIndex !== -1 ? countries.data[itemCountriesIndex] : null
		return (
			<div className="client-edit-page private-page">
				<div className="top-actions-row">
					<Link to="/countries" className="btn-primary btn-roundet btn-dropshadow btn btn-sm"><MaterialIcon icon="arrow_back" /><FormattedMessage id="buttons.back_to_country" /></Link>
				</div>
				<Card className="client-card fadeInLoadUp">
					<Card.Body>
						<CountryForm country={countryData} id={match.params.id} />
					</Card.Body>
				</Card>
			</div>
		)
	}

}
CountryEditPage.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string
		})
	}).isRequired,
	history: PropTypes.shape({
		push: PropTypes.func
	}).isRequired,
	showCountryAction: PropTypes.func.isRequired,
	countries: PropTypes.shape({
		isLoading: PropTypes.bool,
		data: PropTypes.array
	}).isRequired,
}

const mapStateToProps = (state) => ({
	countries: state.countries,
})

export default connect(mapStateToProps, { showCountryAction })(CountryEditPage)
